import { InfoCircleOutlined } from '@ant-design/icons';
import { Checkbox, Form, InputNumber, Tooltip } from 'antd';
import { useRef } from 'react';

import styles from '../ExperienceBulkEdit.module.scss';

export const ExperienceBulkEditValues = () => {
  const form = Form.useFormInstance();
  const stockValue = Form.useWatch('stock', form);
  const inputRef = useRef<HTMLInputElement>(null);
  const isUnlimited = stockValue === null;

  const handleUnlimitedChange = (checked: boolean) => {
    if (checked) {
      form.setFieldValue('stock', null);
    } else {
      form.setFieldValue('stock', 0);
      requestAnimationFrame(() => {
        inputRef.current?.focus();
      });
    }
  };

  return (
    <section className={styles.bulkEditBodyValues}>
      <div className={styles.valuesWrapper}>
        <h2>Edit stock</h2>
        <div className={styles.valuesContainer}>
          <div className={styles.titleBlock}>
            <div className={styles.titleTooltip}>
              <h3>Stock per day</h3>
              <Tooltip
                title="Bookings already made will be deducted from this value"
                placement="top"
              >
                <InfoCircleOutlined color="#BBB" />
              </Tooltip>
            </div>
            <p className={styles.subtitle}>
              Number of activity unit you want to sell for each day
            </p>
          </div>
          <div className={styles.inputContainer}>
            <div className={styles.inlineInput}>
              <span>Publish</span>
              <Form.Item
                shouldUpdate
                name="stock"
                getValueProps={(value) => ({ value: value ?? null })}
                getValueFromEvent={(value) => value ?? null}
              >
                <InputNumber
                  precision={0}
                  type="number"
                  min={0}
                  placeholder="∞"
                  onWheel={(e) => e.currentTarget.blur()}
                />
              </Form.Item>
              <span>stocks per day</span>
            </div>
            <div className={styles.checkboxWrapper}>
              <div className={styles.checkboxRow}>
                <Checkbox
                  checked={isUnlimited}
                  onChange={(e) => handleUnlimitedChange(e.target.checked)}
                />

                <p className={styles.checkboxLabel}>Unlimited (∞)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
